<template>
  <div class="modal fade" id="deleteModal" data-bs-backdrop="static" data-bs-keyboard="true" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
     <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h1 class="modal-title fs-5" id="exampleModalLabel">Delete Role</h1>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <label class="form-label">Role Name</label>
              <v-select v-model="rolesOfProject.id" :options="rolesOfProject" label="roleName" :reduce="rolesOfProject => rolesOfProject.id"
                        placeholder="Please Select a Role"/>
            </div>
            <div class="modal-footer">
              <button class="btn" @click="TryDeleteProjectRole()" data-bs-dismiss="modal" style="background-color: #d51317;color: #ffffff">
                <font-awesome-icon icon="save"/>
                <span class="mx-1">Delete</span>
              </button>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
    import {mapActions, mapState} from "vuex"
    import vSelect from "vue-select";

    export default {
        name: "DeleteRole",
        props: ['isActiveDeleteRoleModal', 'projectId','userId'],
        components:{
          vSelect
        },
        data() {
            return {
                projectRoleForm: {
                    id: 0,
                    roleName: "",
                    projectId: 0,
                    roleId: 0,

                },
                selectedRoleId:0,
            }
        },
        computed: {
            ...mapState('roles', ['roles', 'rolesOfProject']),
        },
        methods: {
            ...mapActions('roles', ['addRole', 'getRolesOfProject', 'deleteRole']),

            openCloseRoleModal() {
                this.projectRoleForm.roleName = "";
                this.$emit('openCloseRoleModal');
            },
            async TryDeleteProjectRole() {
                try {
                    this.projectRoleForm.projectId = parseInt(this.projectId);
                    this.selectedRoleId = parseInt(this.rolesOfProject.id);
                    await this.deleteRole(this.selectedRoleId);
                    await this.getRolesOfProject(this.projectRoleForm.projectId);
                    await this.openCloseRoleModal();
                    this.$notify({title: "Success", type: "success", text: "Successfully deleted role."})
                } catch (e) {
                    this.$notify({title: "Error", type: "error", text: e})
                }
            },
        },
        mounted() {
            document.body.addEventListener('keyup', e => {
                if (e.keyCode === 27)//ESC
                {
                    this.isActiveDeleteRoleModal = false;
                }
            })
        },
    }
</script>

<style scoped>
  .modal-footer{
    background-color: #eff1f3;
  }
</style>
